import axios from "./axios";
import endPoint from "./endpoint";


export const fetchContractRatesList = (payload) =>{
    return axios.post(endPoint.contractRatesList(),payload)
}